import React, { useState, useContext, useEffect } from "react";
import DataTableComponent from "react-data-table-component";

import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import IconButton from "@mui/material/IconButton";
import { Chip } from "@material-ui/core";
import Swal from "sweetalert2";

import Templete from "../../Templete/Templete";
import AuthService from "../../../../services/Admin/AuthService";
import UserService from "../../../../services/Admin/UserService";
import WalletService from "../../../../services/Admin/WalletService";
import HttpError from "../../../../utill/HttpError";
import LoadingContext from "../../../../store/loading-context";
import UserDetailsSection from "./UserDetailsSection";
import WalletStatementSection from "./WalletStatementSection";
import PgReportSection from "./PgReportSection";
import RechargeReportSection from "./RechargeReportSection";

const QuickSearch = (props) => {
  const loadingCtx = useContext(LoadingContext);

  const searchText = props.userId ? props.userId : props.match.params.userId;

  const [fromDate, setFromDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [toDate, setToDate] = useState(new Date().toISOString().slice(0, 10));

  const [userId, setUserId] = useState();

  const handleSetUserId = (userId) => {
    if (userId) {
      setUserId(userId);
    }
  };

  return (
    <React.Fragment>
      <Templete t1="Home" t2="Quick Search">
        <UserDetailsSection
          handleSetUserId={handleSetUserId}
          searchText={searchText}
        />

        <WalletStatementSection userId={userId} searchText={searchText} />

        <PgReportSection userId={userId} searchText={searchText} />

        <RechargeReportSection userId={userId} searchText={searchText} />
      </Templete>
    </React.Fragment>
  );
};

export default QuickSearch;
